import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Login from './components/login';
import IsAuthenticatedWrapper from './components/login/isAuthenticatedWrapper';

import './app.scss'

import Layout from './components/layout/Layout'
import Logout from './components/login/logout';
import JobStatus from './components/jobStatus/JobStatus';

const NotFound = React.lazy(() => import('./views/errors/not-found.component'))
const Courses = React.lazy(() => import('./components/courses/course-list'))
const Course = React.lazy(() => import('./components/courses/course-details'))
const Classes = React.lazy(() => import('./components/classes/class-list'))
const Consumers = React.lazy(() => import('./components/consumers/consumer-list'))
const Consumer = React.lazy(() => import('./components/consumers/consumer-details'))
const Jobstatus = React.lazy(() => import('./components/jobStatus'))
const TradeRulesList = React.lazy(() => import('./components/tradeRules/tradeRule-list'))
const SetupTradeRule = React.lazy(() => import('./components/tradeRules/tradeRule-details'))
const Reports = React.lazy(() => import('./components/reports'))


function App() {
	return (
		<Router>
			<React.Suspense fallback={<span>Loading...</span>}>
				<Switch>
					<Route exact path="/">
						<Redirect to="/courses" />
					</Route>
					<Route exact path="/login">
						<Login />
					</Route>
					<Route exact path="/logout">
						<Logout />
					</Route>
					<IsAuthenticatedWrapper>
						<Layout>
							<Route exact path="/courses" component={Courses} />
							<Route exact path="/courses/:id" component={(props) => <Course {...props} readOnlyMode={true} />} />
							<Route exact path="/courses/edit/:id" component={(props) => <Course {...props} readOnlyMode={false} />} />
							<Route exact path="/classes" component={Classes} />
							<Route exact path="/consumers" component={Consumers} />
							<Route exact path="/consumers/edit/:id" component={Consumer} />
							<Route exact path="/jobstatus" component={Jobstatus} />
							<Route exact path="/reports" component={Reports} />
							<Route exact path="/tradeRules" component={TradeRulesList} />
							<Route exact path="/setupTradeRule" component={(props) => <SetupTradeRule {...props} />} />
						</Layout>
					</IsAuthenticatedWrapper>
					<Route path="*">
						<NotFound />
					</Route>
				</Switch>
			</React.Suspense>
		</Router>
	)
}

export default App
